<div
  class="design-container"
  cdkDropList
  class="example-list"
  [id]="cellId"
  (cdkDropListDropped)="drop($event)"
  [cdkDropListConnectedTo]="getConnectedLists()"
  [cdkDropListData]="columnData"
>
  <div
    (mouseenter)="hoveredComponent = item.id"
    (mouseleave)="hoveredComponent = null"
    class="component-wrapper-component"
    *ngFor="let item of componentsList"
    cdkDrag
    [cdkDragData]="item"
  >
    <ng-container
      *ngComponentOutlet="
        components[item.name];
        inputs: {
          componentId: item.id,
        }
      "
    >
    </ng-container>
    <button
      *ngIf="hoveredComponent === item.id"
      mat-icon-button
      class="component-action"
      (click)="openPopup(item); $event.stopPropagation()"
      aria-label="Settings"
    >
      <mat-icon>settings</mat-icon>
    </button>
  </div>
  <div *ngIf="newComponentsList.length === 0" class="empty-cell">
    <div class="empty-cell-background">drop here</div>
  </div>
</div>
